module.exports = __webpack_public_path__ + "img/gxpd.e711d298.jpg";